import axios from 'axios'

const request = async (query, params) => {
  const response = await axios.get('/', {
    baseURL: process.env.GRAPHQL,
    params: { params, query }
  })

  return response
}

export default request



// WEBPACK FOOTER //
// ./src/graphQL/index.js